module.exports = __webpack_public_path__ + "static/media/foto 3 aruntani.aff4fbc6.jpg";